import { TestMcpBodySchema, TestMcpResponseSchema } from "schema"
import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { z } from "zod"

type TestMCPBody = z.infer<typeof TestMcpBodySchema>
type TestMCPResponse = z.infer<typeof TestMcpResponseSchema>

interface Response {
  data: TestMCPResponse
}

export function useTestMCPConnectionMutation() {
  return useMutation({
    mutationFn: async (body: TestMCPBody) => {
      const response = await axios.post<Response>("/capabilities/test-mcp", body)
      return response.data.data
    },
  })
}
